// The shapes the shared PlacePicker speaks (D13, issue 57).
//
// A location is a NAME plus, optionally, a real settlement from the shipped
// GeoNames extract. Nothing is ever inferred from it: the street and postal code
// stay the customer's own typed text, and a location with no place ("Remote",
// "Werk Nord") is an ordinary location, not an incomplete one.
//
// These types live here rather than in PlacePicker.vue because `<script setup>`
// cannot carry named exports.

/** A picked place, exactly as the OrgUnit columns store it. */
export interface PickedPlace {
  placeId: number;
  placeName: string;
  placeCountryCode: string;
  placeLatitude: number;
  placeLongitude: number;
}

/** One row of `GET /places/search` (people-api/src/places/places.service.ts). */
export interface PlaceSearchResult {
  placeId: number;
  // GeoNames' own primary name — the internationally common form ("Munich",
  // "Warsaw"), which is why `localizedName` wins when the dataset has one.
  name: string;
  localizedName: string | null;
  // The alternate name the query matched, when it matched through one.
  matchedName: string | null;
  countryCode: string;
  latitude: number;
  longitude: number;
  population: number;
}

// The server's own floor (people-api/src/places/place-name.util.ts). Below it the
// endpoint answers empty rather than 400, but there is no reason to spend a
// request — and the search is rate limited per tenant (ADR 0046), so not asking
// is how the client stays inside that budget.
export const MIN_PLACE_QUERY_LENGTH = 2;
// Long enough that an ordinary typist produces one request per word rather than
// one per keystroke; short enough that the list does not feel late.
export const PLACE_SEARCH_DEBOUNCE_MS = 300;
export const PLACE_SEARCH_LIMIT = 10;
